
        <ngx-one-column-layout>
            <nb-menu [items]="menu"></nb-menu>      
            <router-outlet></router-outlet>            
        </ngx-one-column-layout> 
    